import React from 'react';
import { styled } from '@mui/material/styles';
import { Modal, Box, Card, CardContent, Typography } from '@mui/material';

/** Rol seçim / kayıt popup ile aynı konumlandırma ve genişlik */
export const StandardModalContainer = styled(Box)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '95%',
  maxWidth: 500,
  padding: 0,
  outline: 'none',
  borderRadius: 16,
  overflow: 'hidden',
}));

export const STANDARD_MARKETING_MODAL_HEADER_SX = {
  py: 3,
  px: 3,
  textAlign: 'center' as const,
  background: 'linear-gradient(to right, #0D47A1, #1976D2)',
  color: 'white' as const,
};

interface StandardMarketingModalProps {
  open: boolean;
  onClose: () => void;
  titleId?: string;
  title: React.ReactNode;
  children: React.ReactNode;
  /** px cinsinden; varsayılan 500 (rol seçim modalı ile aynı) */
  maxWidth?: number;
}

/**
 * Ön muhasebe / e-ticaret / QR menü / kiosk iletişim formları ve benzeri;
 * personel–yönetici seçim popup ile aynı kart + gradient başlık dili.
 */
export const StandardMarketingModal: React.FC<StandardMarketingModalProps> = ({
  open,
  onClose,
  titleId = 'standard-marketing-modal-title',
  title,
  children,
  maxWidth,
}) => (
  <Modal open={open} onClose={onClose} aria-labelledby={titleId}>
    <StandardModalContainer sx={maxWidth != null ? { maxWidth } : undefined}>
      <Card elevation={5} sx={{ width: '100%', overflow: 'hidden' }}>
        <Box sx={STANDARD_MARKETING_MODAL_HEADER_SX}>
          <Typography
            id={titleId}
            variant="h5"
            component="h2"
            fontWeight="bold"
            sx={{ wordBreak: 'break-word' }}
          >
            {title}
          </Typography>
        </Box>
        <CardContent sx={{ p: 4 }}>{children}</CardContent>
      </Card>
    </StandardModalContainer>
  </Modal>
);

/** Kayıt / login formlarıyla uyumlu input köşesi */
export const marketingModalTextFieldSx = {
  '& .MuiOutlinedInput-root': { borderRadius: '12px' },
} as const;
